import React, { useState, useCallback, useEffect } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "1000px",
    borderRadius: "8px",
};

const defaultCenter = {
    lat: 40.7128,
    lng: -74.006,
};

export default function InteractiveMap({ initialCoordinates, onLocationSelect }) {
    // console.log("inditialCoordinates", initialCoordinates);
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API,
    });

    const [selectedPosition, setSelectedPosition] = useState(null);
    const [address, setAddress] = useState("");

    // ⬇️ Set the initial coordinates if available (e.g., from registration)
    //   useEffect(() => {
    //     if (initialCoordinates?.lat && initialCoordinates?.lng) {
    //       setSelectedPosition(initialCoordinates);

    //       // Optional: fetch address for initial location
    //       const geocoder = new window.google.maps.Geocoder();
    //       geocoder.geocode(
    //         { location: initialCoordinates },
    //         (results, status) => {
    //           if (status === "OK" && results[0]) {
    //             setAddress(results[0].formatted_address);
    //             onLocationSelect?.({
    //               lat: initialCoordinates?.lat,
    //               lng: initialCoordinates?.lng,
    //               address: results[0]?.formatted_address,
    //             });
    //           }
    //         }
    //       );
    //     }
    //   }, [initialCoordinates, onLocationSelect]);


    useEffect(() => {
        if (
            isLoaded &&
            initialCoordinates?.lat &&
            initialCoordinates?.lng &&
            window.google &&
            window.google.maps
        ) {
            setSelectedPosition(initialCoordinates);

            // Optional: fetch address for initial location
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode(
                { location: initialCoordinates },
                (results, status) => {
                    if (status === "OK" && results[0]) {
                        setAddress(results[0].formatted_address);
                        onLocationSelect?.({
                            lat: initialCoordinates?.lat,
                            lng: initialCoordinates?.lng,
                            address: results[0]?.formatted_address,
                        });
                    }
                }
            );
        }
    }, [isLoaded, initialCoordinates, onLocationSelect]);

    const handleMapClick = useCallback(
        (event) => {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            const newPosition = { lat, lng };

            setSelectedPosition(newPosition);

            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: newPosition }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setAddress(results[0].formatted_address);
                    onLocationSelect?.({
                        lat,
                        lng,
                        address: results[0].formatted_address,
                    });
                }
            });
        },
        [onLocationSelect]
    );

    if (!isLoaded) return <div>Loading map...</div>;

    return (
        <div className="map-container">
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={selectedPosition || defaultCenter}
                zoom={14}
                onClick={handleMapClick}
            >
                {selectedPosition && <Marker position={selectedPosition} />}
            </GoogleMap>

            {address && (
                <div style={{ marginTop: "10px" }}>
                    <strong>Selected Address:</strong> {address}
                </div>
            )}
        </div>
    );
}
